class NewsletterPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;
    this.key = 'stubbrn-newsletter-dismissed';
    this.signup = this.querySelector('[data-np-signup]');
    this.success = this.querySelector('[data-np-success]');
    this.form = this.querySelector('form');

    let dismissed = false;
    try { dismissed = !!localStorage.getItem(this.key); } catch (_) {}

    const params = new URLSearchParams(location.search);
    const justPosted = params.get('customer_posted') === 'true' || !!this.querySelector('[data-signup-success]');
    const hasError = !!this.querySelector('[role="alert"]');

    this.dialog.addEventListener('close', () => {
      this.remember();
      this.previousFocus?.focus();
    });

    this.form?.addEventListener('submit', (event) => this.submit(event));

    let fromFooter = false;
    try { fromFooter = sessionStorage.getItem('stubbrn-signup-source') === 'footer'; sessionStorage.removeItem('stubbrn-signup-source'); } catch (_) {}
    document.querySelector('.site-footer form')?.addEventListener('submit', () => {
      try { sessionStorage.setItem('stubbrn-signup-source', 'footer'); } catch (_) {}
    });

    if (fromFooter && (justPosted || hasError)) {
      // Signed up (or mistyped) in the footer: the footer shows the result, so keep the popup closed.
      if (justPosted) this.remember();
    } else if (justPosted) {
      this.showSuccess();
      this.timer = setTimeout(() => this.open(), 100);
    } else if (hasError) {
      this.timer = setTimeout(() => this.open(), 100);
    } else if (!dismissed) {
      this.timer = setTimeout(() => this.open(), 8000);
    }
  }

  disconnectedCallback() { clearTimeout(this.timer); }

  remember() {
    try { localStorage.setItem(this.key, '1'); } catch (_) {}
  }

  open() {
    if (this.dialog.open) return;
    if (document.querySelector('dialog[open]')) {
      this.timer = setTimeout(() => this.open(), 1000);
      return;
    }
    this.previousFocus = document.activeElement;
    this.dialog.showModal();
  }

  showSuccess() {
    if (this.signup) this.signup.hidden = true;
    if (this.success) this.success.hidden = false;
    this.dialog.setAttribute('aria-label', this.success?.querySelector('h2')?.textContent.trim() || '');
    this.dialog.removeAttribute('aria-labelledby');
    this.remember();
  }

  async submit(event) {
    if (!window.fetch) return;
    event.preventDefault();
    const form = event.currentTarget;
    const button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    try {
      const response = await fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' });
      if (response.redirected && /challenge/.test(response.url)) {
        form.submit();
        return;
      }
      const html = await response.text();
      const page = new DOMParser().parseFromString(html, 'text/html');
      const error = page.querySelector('newsletter-popup [role="alert"]');
      if (!response.ok || error) {
        form.submit();
        return;
      }
      this.showSuccess();
    } catch (_) {
      form.submit();
    } finally {
      if (button) button.disabled = false;
    }
  }
}
if (!customElements.get('newsletter-popup')) customElements.define('newsletter-popup', NewsletterPopup);
